// Modules
import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import Person from 'services/data/person';

// Components
// import CompanyNickname from 'components/models/company/company-nickname';


// Component
export default class CompanyRow extends React.PureComponent {
  render() {
    const { company } = this.props;
    const hasTeam = _.get(company, 'team.id');
    const hasTech = _.get(company, 'primaryTech.id');

    return (
      <tr>
        <td><Link to={`/companies/${company.id}`} >{company.name}</Link></td>
        <td>
          { hasTeam &&
            <span><span className="color-dot" style={{ backgroundColor: company.team.color }}></span>{company.team.name}</span>
          }
        </td>
        <td>{ hasTech && <Link to={`/people/${company.primaryTech.id}`} >{Person.fullName(company.primaryTech)}</Link> }</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/company/company-row.js